const DrugFactBullet = () => {
  return <div className='drug-fact__square-bullet'></div>;
};

export default DrugFactBullet;
